import type { UserProject } from '@internal/types/experience';

export const finishDeps: Array<keyof UserProject> = [
  'name',
  'description',
  'link',
  'tech_stack',
  'responsibilities',
  'role',
  'startDate',
  'endDate',
];

export function isUserProjectFinished(project: UserProject): boolean {
  return finishDeps.every(key => Boolean(project[key]));
}
